import React from 'react';

import { Button } from '@coursera/cds-core';
import { ReplyIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/discussions';

type ReplyButtonProps = {
  handleClick?: () => void;
  text: string;
  creator: { fullName: string };
};

const ReplyButton: React.FC<ReplyButtonProps> = ({ handleClick, text, creator }) => {
  const ariaLabel = creator?.fullName
    ? _t(`#{text} to #{userName}'s post`, { text, userName: creator?.fullName })
    : text;

  return (
    <Button
      className="rc-ReplyButton"
      onClick={handleClick}
      aria-label={ariaLabel}
      variant="ghost"
      size="small"
      iconPosition="before"
      icon={<ReplyIcon size="small" />}
    >
      {text}
    </Button>
  );
};

export default ReplyButton;
